export const backendBaseUrl = (import.meta.env.VITE_API_BASE_URL ?? 'https://pms.emiratesproperties.com').replace(/\/+$/, '');

export function backendUrl(path) {
  if (/^(https?:|blob:|data:)/i.test(path)) return path;
  return `${backendBaseUrl}/${path.replace(/^\/+/, '')}`;
}

export async function backendHeaders(json = false) {
  const headers = { Accept: 'application/json' };
  if (json) headers['Content-Type'] = 'application/json';
  // Read from the backend session each time, including after login/logout or
  // another tab changes sessions. Never cache this token in browser storage.
  const response = await fetch(backendUrl('/api/method/amc_management.api.vendor_portal_api.get_portal_csrf_token'), {
    method: 'GET', credentials: 'include', cache: 'no-store', headers: { Accept: 'application/json' },
  });
  const data = await response.json();
  if (!response.ok || data.exc || data.exc_type || !data.message || !Object.hasOwn(data.message, 'csrf_token')) {
    throw new Error('Unable to initialize the backend session. Please reload and try again.');
  }
  if (data.message.csrf_token) headers['X-Frappe-CSRF-Token'] = data.message.csrf_token;
  return headers;
}

export async function backendRequest({ url, params, method = 'POST', headers = {} }) {
  const target = new URL(backendUrl(url.startsWith('/') || /^https?:/.test(url) ? url : `/api/method/${url}`), window.location.origin);
  const isGet = method.toUpperCase() === 'GET';
  if (isGet && params) for (const [key, value] of Object.entries(params)) target.searchParams.set(key, value);
  const response = await fetch(target.href, {
    method,
    credentials: 'include',
    headers: { ...(isGet ? { Accept: 'application/json' } : await backendHeaders(true)), ...headers },
    ...(isGet ? {} : { body: JSON.stringify(params || {}) }),
  });
  const data = await response.json();
  if (!response.ok || data.exc || data.exc_type) {
    let messages = [];
    try {
      messages = JSON.parse(data._server_messages || '[]').map((message) => {
        try { return JSON.parse(message).message; } catch { return message; }
      });
    } catch { /* Fall back to the API error message. */ }
    const error = new Error(messages[0] || data._error_message || (typeof data.message === 'string' ? data.message : 'Request failed'));
    error.messages = messages;
    error.status = response.status;
    throw error;
  }
  return data.docs ? data : data.message;
}
